import React, { useEffect, useState } from 'react';
import { centerClient } from '../shared/clients';
import type { SoapUser, SoapUsers } from '../shared/generated';
import { ReactComponent as ApiSvg } from '../assets/api.svg';
import { Button, ButtonGroup, Modal } from 'react-bootstrap';
import { ColDef, RowClassParams } from 'ag-grid-community';
import { toast } from 'react-toastify';
import AddApiUserDialog from './AddApiUserDialog';
import { AG_GRID_LOCALE_RU } from 'blick.react.aggrid';
import { Floppy2Fill } from 'react-bootstrap-icons';
import { BlickAgGrid } from 'blick.react.aggrid';

export interface IApiUser {
    Login: string;
    ApiKey: string;
}
class ApiSettingsDialogProps {
    buttonVariant: 'custom' | 'transparent' = 'transparent';
    buttonText?: string = '';
}
const ApiSettingsDialog = (props: ApiSettingsDialogProps) => {
    const { buttonVariant, buttonText } = props;
    const [open, setOpen] = useState(false);
    const [rowData, setRowData] = useState<IApiUser[]>([]);
    const [loading, setLoading] = useState(false);
    const [addUserDialogOpen, setAddUserDialogOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState<IApiUser[]>([]);

    const columnDefs: ColDef[] = [
        { field: 'row-number', valueGetter: "node.rowIndex + 1", width: 50, resizable:false, headerName: '№', sortable: true, filter: false },
        { field: 'Login', headerName: 'Логин', sortable: true, filter: false },
        { field: 'ApiKey', headerName: 'Api-ключ', sortable: true, filter: false },
        {
            field: 'save', headerName: 'Файл', width:100, sortable: true, filter: false,
            cellRenderer: (row) => {
                return <Button style={{ padding:'0 .5rem' }} variant='transparent' onClick={() => downloadApiSettings(row.data)}><Floppy2Fill /></Button>
            }
        },

    ];
    const handleDownload = (row: IApiUser) => {
        const text = `<cen:APIKey>${row.ApiKey}</cen:APIKey><cen:login>${row.Login}</cen:login>`;
        const blob = new Blob([text], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${row.Login}.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    const downloadApiSettings = (row) => {
        handleDownload(row);
    }
    const fetchSoapUsers = async () => {
        setLoading(true);
        centerClient.getSoapUsers()
            .then((res) => {
                const data = res.data;
                if (data)
                    setRowData(data.Users as unknown as IApiUser[]);
            })
            .catch(() => setRowData([]))
            .finally(() => setLoading(false));
    };
    const deleteSoapUsers = async () => {
        if (selectedRows.length === 0) {
            toast.info('Выберите хотя бы одну запись для удаления.');
            return;
        }

        const loginsToDelete = selectedRows;
        const usersToDelete: SoapUsers = {
            Users: loginsToDelete as unknown as SoapUser[]
        }
        centerClient.deleteSoapUsers(usersToDelete)
            .then(() => {
                toast.success('Пользователи успешно удалены!');
                fetchSoapUsers();
            })
            .catch(() => void 0);
    };
    useEffect(() => {
        if (open) {
            fetchSoapUsers();
        }
    }, [open]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleAddUserDialogOpen = () => setAddUserDialogOpen(true);
    const handleAddUserDialogClose = () => setAddUserDialogOpen(false);

    const handleUserAdded = () => fetchSoapUsers();
    const getRowStyle = (row: RowClassParams) => {
        const selected = row.node.isSelected();
        return {
            selectedHover: selected ? "var(--selected-row-hover)" : "",
            afterColor: selected ? "var(--selected-row)" : "",
            backgroundColor: "var(--bg)",
            background:  "var(--bg)",
            color: selected ? "var(--text-dark)" : 'var(--text)',
            stroke: selected ? "var(--text-dark)" : 'var(--text)',
        }
    }
    return (
        <>
            <Button variant={buttonVariant} onClick={handleOpen}>
                <ApiSvg className='svg' />
                { buttonText}
            </Button>
            <Modal id="addApiUserContainer" show={open} onHide={handleClose} >
                <Modal.Header closeButton>
                    <Modal.Title>Настройки API</Modal.Title>
                </Modal.Header>
                <Modal.Body>               
                    <ButtonGroup className="mb-3">
                        <Button variant="custom" onClick={handleAddUserDialogOpen}>
                                Добавить
                            </Button>
                        <Button variant="custom" onClick={deleteSoapUsers}>
                                Удалить
                        </Button>
                    </ButtonGroup>
                    <div
                        style={{ height: 400, width:'100%', maxHeight: 'clamp(250px, calc(100vh - 9rem), 9999px)' }}
                    >
                        <BlickAgGrid
                            showRestoreColumnsButton={true}
                            rowData={rowData}
                            localeText={AG_GRID_LOCALE_RU}
                            columnDefs={columnDefs}
                            //theme={myAgReactTheme}
                            getRowStyle={getRowStyle}
                            onModelUpdated={(e) => e.api.refreshCells()}

                            rowSelection={{
                                mode: "multiRow",
                                checkboxes: true,
                            }}       
                            loadingOverlayComponentParams={{
                                loadingMessage: 'Загрузка...',
                            }}
                            onSelectionChanged={(e) =>
                                setSelectedRows(e.api.getSelectedRows())
                            }
                            overlayLoadingTemplate={
                                loading
                                    ? '<span class="ag-overlay-loading-center">Загрузка...</span>'
                                    : ''
                            }
                        />                            
                    </div>           
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="custom" onClick={handleClose}>
                        Закрыть
                    </Button>
                </Modal.Footer>
            </Modal>    
            <AddApiUserDialog
                open={addUserDialogOpen}
                onClose={handleAddUserDialogClose}
                onUserAdded={handleUserAdded}
            />
        </>
    );
};

export default ApiSettingsDialog;